import { Link } from 'react-router-dom';
import { AGENT_SETUP_BASE } from '../../constants/setupRoadmapSteps';
import styles from '../../styles/workflows.module.css';

function WorkflowCard({ workflow, onDelete, onExecute }) {
    const stepCount = workflow.stepCount || 0;
    
    return (
        <div className={styles.card}>
            <div className={styles.cardHeader}>
                <h3 className={styles.cardTitle}>{workflow.name}</h3>
                <span className={`${styles.cardBadge} ${workflow.isActive ? styles.badgeActive : styles.badgeInactive}`}>
                    {workflow.isActive ? 'Active' : 'Inactive'}
                </span>
            </div>
            
            {workflow.description && (
                <p className={styles.cardDescription}>{workflow.description}</p>
            )}
            
            <div className={styles.cardMeta}>
                <div className={styles.metaItem}>
                    <span>⚙️</span>
                    <span>{stepCount} {stepCount === 1 ? 'step' : 'steps'}</span>
                </div>
                <div className={styles.metaItem}>
                    <span>🆔</span>
                    <span>{workflow.workflowId}</span>
                </div>
            </div>
            
            <div className={styles.cardActions}>
                <Link
                    to={`${AGENT_SETUP_BASE}/workflows/${workflow.workflowId}`}
                    className={styles.cardButton}
                >
                    Edit
                </Link>
                {onExecute && (
                    <button
                        onClick={() => onExecute(workflow.workflowId)}
                        className={styles.cardButton}
                    >
                        Execute
                    </button>
                )}
                {onDelete && (
                    <button
                        onClick={() => onDelete(workflow.workflowId)}
                        className={`${styles.cardButton} ${styles.cardButtonDanger}`}
                    >
                        Delete
                    </button>
                )}
            </div>
        </div>
    );
}

export default WorkflowCard;
